module.exports = " <select v-el:tags multiple=multiple tabindex=0></select> <input type=hidden :name=name :value=data|json class=form-control /> ";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-html-loader!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/statamic/resources/js/components/fieldtypes/relate/RelateTagsFieldtype.vue
// module id = 624
// module chunks = 0